import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

import { useAppSelector } from "../../app/hook";
import { useGetProfileQuery } from "../../app/services/auth-rtk.service";
import { useCreateContactUsMutation } from "../../app/services/chatbot-rtk.services";
import { AlertsType } from "../../constants/alerts.constant";
import { MultiLanguageUrl } from "../../constants/multiLanguage.constant";
import { selectUserProfile } from "../../features/auth/auth.slice";

const schema = Yup.object({
  message: Yup.string().required().min(10).max(3500).required().label("Message")
});

const ContactUs = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm({
    defaultValues: {
      message: ""
    },
    resolver: yupResolver(schema)
  });

  const { i18n } = useTranslation();
  const navigation = useNavigate();
  const [counter, setCounter] = useState(0);

  const [getProfile, setGetProfile] = useState(true);

  const profileRequest = useGetProfileQuery(undefined, {
    skip: getProfile
  });

  const profile = useAppSelector(selectUserProfile);

  const [ContactUsRequest, ContactUsRequestStatus] =
    useCreateContactUsMutation();

  useEffect(() => {
    if (!profile || !profile.user_email) {
      setGetProfile(false);
    }
  }, [profile]);

  const onSubmit = (values: any) => {
    let firstName: string | undefined = "";
    if (profile?.user_first_name && profile.user_last_name) {
      firstName = profile?.user_first_name + " " + profile.user_last_name;
    } else {
      firstName = profile?.user_email;
    }

    if (counter <= 0) {
      ContactUsRequest({
        email: profile?.user_email as string,
        message: values.message
      })
        .unwrap()
        .then((res) => {
          if (res && res.message) {
            setCounter(counter + 1);
            toast.success(res.message);
            reset();
            navigation(
              `/${MultiLanguageUrl[i18n.language] || "en-US"}/control-panel`
            );
          }
        })
        .catch((res) => {
          if (res) {
            toast.error(t(AlertsType.ISCUKO001));
          }
          reset();
        });
    } else {
      toast.error(t(AlertsType.ISCUKO002));
    }
  };

  return (
    <section className="dashboard-contactUs  p-0">
      <Row className="m-0 h-100">
        <Col className="p-0 m-0 ">
          <Form onSubmit={handleSubmit(onSubmit)} className="h-100">
            <Row className="border-bottom py-2 m-0">
              <Col lg="9" sm="9" xs="9" className="py-0 px-2">
                <h3 className="m-0 px-2">{t("DashboardContactUs/title")}</h3>
              </Col>
              <Col
                lg="3"
                sm="3"
                xs="3"
                className="py-0 px-2 tw-flex tw-justify-end "
              >
                <Button
                  variant="primary"
                  type="submit"
                  className="tw-invisible md:tw-visible"
                >
                  {t("DashboardContactUs/btn-01")}
                </Button>
              </Col>
            </Row>
            <div className="d-flex justify-content-between flex-column h-100">
              <Row className="md:tw-px-32 md:tw-py-10 m-0">
                <Col>
                  <Row>
                    <Col className="px-3">
                      <Row>
                        <h2 className="font-sofiaSans">
                          {t("DashboardContactUs/t-01")}
                        </h2>
                      </Row>
                      <Row className="mt-3">
                        <Form.Group>
                          <Form.Label className="font-sofiaSans tw-text-zinc-500">
                            {t("DashboardContactUs/l-01")}
                          </Form.Label>
                          <Form.Control
                            isInvalid={!!errors.message}
                            id="message"
                            as={"textarea"}
                            rows={5}
                            {...register("message")}
                          />
                        </Form.Group>
                        <Form.Control.Feedback
                          type="invalid"
                          className="d-block font-poppins"
                        >
                          {errors.message?.message}
                        </Form.Control.Feedback>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="py-3 border-top md:tw-hidden  tw-block m-0">
                <Col className="d-flex justify-content-end align-items-center gap-3">
                  <Button variant="primary" size="sm" type="submit">
                    {t("DashboardContactUs/btn-01")}
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Col>
      </Row>
    </section>
  );
};

export default ContactUs;
